// src/components/StartPageSetter.jsx
import React, { useState, useEffect } from "react";

// Простий UI для збереження / очищення preferred стартової сторінки
export default function StartPageSetter({ label = "Встановити як стартову" }) {
  const [current, setCurrent] = useState(null);
  const [status, setStatus] = useState("");

  useEffect(() => {
    try {
      const v = localStorage.getItem("preferred_start");
      setCurrent(v);
    } catch (e) {
      setCurrent(null);
    }
  }, []);

  const getPath = () => {
    try {
      // беремо шлях з location + search + hash (щоб зберігати будь-які параметри)
      return window.location.pathname + window.location.search + window.location.hash;
    } catch {
      return "/date";
    }
  };

  const setAsStart = () => {
    const p = getPath();
    try {
      localStorage.setItem("preferred_start", p);
      setCurrent(p);
      setStatus("Збережено");
      setTimeout(() => setStatus(""), 1800);
    } catch (e) {
      setStatus("Помилка збереження");
    }
  };

  const clearStart = () => {
    try {
      localStorage.removeItem("preferred_start");
      setCurrent(null);
      setStatus("Скинуто");
      setTimeout(() => setStatus(""), 1800);
    } catch (e) {
      setStatus("Помилка");
    }
  };

  const openInstallHelp = () => {
    // Пояснити користувачеві — не намагаємось автоматично викликати install prompt
    alert(
"Щоб встановити застосунок:\n\n" +
"1. Спочатку обери свій розклад (студент / викладач / група).\n" +
"2. Натисни «Зробити стартовою цю сторінку» — це збереже саме твій розклад.\n" +
"3. Потім натисни «📲 Встановити застосунок» у футері.\n\n" +
"Після встановлення додаток відкриватиме саме ту сторінку, яку ти зберіг."

    );
  };

  return (
    <div className="flex flex-col items-center gap-2 text-sm">
      <div className="flex gap-2">
        <button
          onClick={setAsStart}
          className="px-3 py-1 rounded-md border bg-primary text-white hover:opacity-90 transition"
          title="Зробити поточну сторінку стартовою при відкритті додатку"
        >
          {label}
        </button>

        <button
          onClick={clearStart}
          className="px-3 py-1 rounded-md border hover:bg-muted transition"
          title="Очистити збережену стартову сторінку"
        >
          Скинути
        </button>

        <button
          onClick={openInstallHelp}
          className="px-3 py-1 rounded-md border hover:bg-muted transition"
          title="Як встановити PWA"
        >
          Як встановити
        </button>
      </div>

      <div className="text-xs text-muted-foreground">
        <div>
          Поточний старт:{" "}
          <span className="font-medium">{current || "/date (за замовчуванням)"}</span>
        </div>
        <div className="text-[11px] text-muted-foreground/80 mt-1">
          Порада: перед встановленням PWA натисни «{label}», потім встанови ярлик.
        </div>
        {status && <div className="mt-1 text-xs font-medium">{status}</div>}
      </div>
    </div>
  );
}


